"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectedPlatform = void 0;
class ConnectedPlatform {
    constructor({ id, type, name, image, connected_at, inactive } = {
        id: null,
        type: null,
        name: null,
        image: null,
        connected_at: {},
        inactive: {},
    }) {
        this.id = id;
        this.type = type;
        this.name = name;
        this.image = image;
        this.connected_at = connected_at;
        this.inactive = inactive;
    }
    get serviceId() {
        return this.type + '_' + this.id;
    }
}
exports.ConnectedPlatform = ConnectedPlatform;
//# sourceMappingURL=connectedplatform.js.map